import {
  Button,
  IconValidationValid,
  Text,
} from '@adc/parallax-component-library';
import { Dialog } from '@tamagui/dialog';

import { useModal } from '~/features/modals/useModal';
import { buildTestId } from '~/utils/buildTestId';

import { ModalContent } from '../ModalContent';
import { ModalOverlay } from '../ModalOverlay';

type AccountActivatedModalProps = {
  testID: string;
};

export const AccountActivatedModal = ({
  testID,
}: AccountActivatedModalProps) => {
  const { closeModal } = useModal();

  const onClose = () => {
    closeModal('AccountActivated');
  };

  const onOpenChange = (open: boolean) => {
    if (!open) {
      onClose();
    }
  };

  return (
    <Dialog open onOpenChange={onOpenChange} modal>
      <Dialog.Portal testID={buildTestId({ testID, suffix: 'portal' })}>
        <ModalOverlay testID={buildTestId({ testID, suffix: 'overlay' })} />

        <ModalContent
          testID={testID}
          key="content"
          maxWidth={800}
          alignItems="center"
        >
          <IconValidationValid
            size="XL"
            color="$support.positive.default"
            testID={buildTestId({
              testID,
              suffix: 'checkmark',
            })}
          />
          <Text
            type="$h3.medium"
            testID={buildTestId({
              testID,
              suffix: 'title',
            })}
          >
            Account Activated
          </Text>

          <Text
            type="$bodySmall.default"
            color="$text.60"
            paddingTop="$3"
            testID={buildTestId({
              testID,
              suffix: 'summary',
            })}
          >
            Welcome to LactateView
          </Text>

          <Button
            variant="primary"
            label="Done"
            onPress={onClose}
            marginTop="$6"
            // @ts-expect-error Parallax doesn't type this prop
            minWidth={256}
            testID={buildTestId({
              testID,
              suffix: ['button', 'done'],
            })}
          />
        </ModalContent>
      </Dialog.Portal>
    </Dialog>
  );
};
